import React from 'react';

export default class MenuContacts extends React.PureComponent {
  render() {
    return (
      <div>
        <a href="#" onClick={(e) => {e.preventDefault(); this.props.onNewTopic();}} title="Register node" className="console-symbol">+</a>
        &nbsp;
        <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSettings();}} className="console-symbol">CFG</a>
        &nbsp;
        <a href="#" onClick={(e) => {e.preventDefault(); this.props.onLockScreen();}}
          title="Lock session (Alt+L)" className="console-symbol console-lock">LOCK</a>
      </div>
    );
  }
};
